import {
  BadgeAlert,
  Building2,
  ClipboardList,
  Gauge,
  PoundSterling,
  ScanBarcode,
  ShieldBan,
  Wrench,
} from "lucide-react";

const ICONS = {
  "service-history": ClipboardList,
  stolen: ShieldBan,
  "write-off": BadgeAlert,
  mileage: Gauge,
  garage: Building2,
  work: Wrench,
  vin: ScanBarcode,
  finance: PoundSterling,
};

const SIZES = {
  sm: 16,
  md: 22,
  lg: 28,
  watermark: 148,
};

export default function RiskCheckIcon({ name, size = "md", className = "" }) {
  const Icon = ICONS[name];
  if (!Icon) return null;

  const px = SIZES[size] ?? SIZES.md;

  return (
    <Icon
      size={px}
      strokeWidth={size === "watermark" ? 1.15 : 2}
      className={`risk-check-icon risk-check-icon--${size}${className ? ` ${className}` : ""}`}
      aria-hidden="true"
    />
  );
}
